/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addSubVenue } from '../fn/venue/add-sub-venue';
import { AddSubVenue$Params } from '../fn/venue/add-sub-venue';
import { addVenue } from '../fn/venue/add-venue';
import { AddVenue$Params } from '../fn/venue/add-venue';
import { deleteSubVenue } from '../fn/venue/delete-sub-venue';
import { DeleteSubVenue$Params } from '../fn/venue/delete-sub-venue';
import { deleteVenue } from '../fn/venue/delete-venue';
import { DeleteVenue$Params } from '../fn/venue/delete-venue';
import { TimeZoneOffsetDto as DigiworkMaitreDDtoAdvertiserTimeZoneOffsetDto } from '../models/Digiwork/MaitreD/DTO/Advertiser/time-zone-offset-dto';
import { VenueDetailsDto as DigiworkMaitreDDtoAdvertiserVenueDetailsDto } from '../models/Digiwork/MaitreD/DTO/Advertiser/venue-details-dto';
import { PairDeviceResponseDto as DigiworkMaitreDDtoAuthenticationPairDeviceResponseDto } from '../models/Digiwork/MaitreD/DTO/Authentication/pair-device-response-dto';
import { MenuCurrencyDto as DigiworkMaitreDPosDtoMenuMenuCurrencyDto } from '../models/Digiwork/MaitreD/Pos/DTO/Menu/menu-currency-dto';
import { getDefaultCurrency_1 } from '../fn/venue/get-default-currency-1';
import { GetDefaultCurrency_1$Params } from '../fn/venue/get-default-currency-1';
import { getMenuItemsForSubvenue } from '../fn/venue/get-menu-items-for-subvenue';
import { GetMenuItemsForSubvenue$Params } from '../fn/venue/get-menu-items-for-subvenue';
import { getVenueDetails } from '../fn/venue/get-venue-details';
import { getVenueDetails_1 } from '../fn/venue/get-venue-details-1';
import { GetVenueDetails_1$Params } from '../fn/venue/get-venue-details-1';
import { GetVenueDetails$Params } from '../fn/venue/get-venue-details';
import { getVenueTimeZoneOffset } from '../fn/venue/get-venue-time-zone-offset';
import { GetVenueTimeZoneOffset$Params } from '../fn/venue/get-venue-time-zone-offset';
import { listSubVenues } from '../fn/venue/list-sub-venues';
import { listSubVenues_1 } from '../fn/venue/list-sub-venues-1';
import { ListSubVenues_1$Params } from '../fn/venue/list-sub-venues-1';
import { ListSubVenues$Params } from '../fn/venue/list-sub-venues';
import { listSubVenuesForCombo } from '../fn/venue/list-sub-venues-for-combo';
import { ListSubVenuesForCombo$Params } from '../fn/venue/list-sub-venues-for-combo';
import { listVenues } from '../fn/venue/list-venues';
import { listVenues_1 } from '../fn/venue/list-venues-1';
import { ListVenues_1$Params } from '../fn/venue/list-venues-1';
import { ListVenues$Params } from '../fn/venue/list-venues';
import { listVenuesForCombo } from '../fn/venue/list-venues-for-combo';
import { listVenuesForCombo_1 } from '../fn/venue/list-venues-for-combo-1';
import { ListVenuesForCombo_1$Params } from '../fn/venue/list-venues-for-combo-1';
import { ListVenuesForCombo$Params } from '../fn/venue/list-venues-for-combo';
import { pairDevice_1 } from '../fn/venue/pair-device-1';
import { PairDevice_1$Params } from '../fn/venue/pair-device-1';
import { unPairDevice_1 } from '../fn/venue/un-pair-device-1';
import { UnPairDevice_1$Params } from '../fn/venue/un-pair-device-1';
import { updateSubVenue } from '../fn/venue/update-sub-venue';
import { UpdateSubVenue$Params } from '../fn/venue/update-sub-venue';
import { updateVenue } from '../fn/venue/update-venue';
import { UpdateVenue$Params } from '../fn/venue/update-venue';

@Injectable({ providedIn: 'root' })
export class VenueService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getDefaultCurrency_1()` */
  static readonly GetDefaultCurrency_1Path = '/api/mng/Venue/getdefaultcurrency';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDefaultCurrency_1()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDefaultCurrency_1$Response(params?: GetDefaultCurrency_1$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoMenuMenuCurrencyDto>> {
    return getDefaultCurrency_1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDefaultCurrency_1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDefaultCurrency_1(params?: GetDefaultCurrency_1$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoMenuMenuCurrencyDto> {
    return this.getDefaultCurrency_1$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoMenuMenuCurrencyDto>): DigiworkMaitreDPosDtoMenuMenuCurrencyDto => r.body)
    );
  }

  /** Path part for operation `listVenues()` */
  static readonly ListVenuesPath = '/api/mng/Venue/listvenues';

  /**
   * Search criteria for venues.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listVenues()` instead.
   *
   * This method doesn't expect any request body.
   */
  listVenues$Response(params?: ListVenues$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return listVenues(this.http, this.rootUrl, params, context);
  }

  /**
   * Search criteria for venues.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listVenues$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listVenues(params?: ListVenues$Params, context?: HttpContext): Observable<void> {
    return this.listVenues$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `listVenuesForCombo()` */
  static readonly ListVenuesForComboPath = '/api/mng/Venue/listvenuesforcombo';

  /**
   * List basic information for venue.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listVenuesForCombo()` instead.
   *
   * This method doesn't expect any request body.
   */
  listVenuesForCombo$Response(params?: ListVenuesForCombo$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return listVenuesForCombo(this.http, this.rootUrl, params, context);
  }

  /**
   * List basic information for venue.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listVenuesForCombo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listVenuesForCombo(params?: ListVenuesForCombo$Params, context?: HttpContext): Observable<void> {
    return this.listVenuesForCombo$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getVenueDetails()` */
  static readonly GetVenueDetailsPath = '/api/mng/Venue/getvenuedetails';

  /**
   * Get venue details for venue id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getVenueDetails()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVenueDetails$Response(params?: GetVenueDetails$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return getVenueDetails(this.http, this.rootUrl, params, context);
  }

  /**
   * Get venue details for venue id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getVenueDetails$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVenueDetails(params?: GetVenueDetails$Params, context?: HttpContext): Observable<void> {
    return this.getVenueDetails$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `pairDevice_1()` */
  static readonly PairDevice_1Path = '/api/mng/Venue/pairdevice';

  /**
   * Pair device with venue by venue manager.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pairDevice_1()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  pairDevice_1$Response(params?: PairDevice_1$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDDtoAuthenticationPairDeviceResponseDto>> {
    return pairDevice_1(this.http, this.rootUrl, params, context);
  }

  /**
   * Pair device with venue by venue manager.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pairDevice_1$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  pairDevice_1(params?: PairDevice_1$Params, context?: HttpContext): Observable<DigiworkMaitreDDtoAuthenticationPairDeviceResponseDto> {
    return this.pairDevice_1$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDDtoAuthenticationPairDeviceResponseDto>): DigiworkMaitreDDtoAuthenticationPairDeviceResponseDto => r.body)
    );
  }

  /** Path part for operation `unPairDevice_1()` */
  static readonly UnPairDevice_1Path = '/api/mng/Venue/unpairdevice';

  /**
   * Un pair the device.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `unPairDevice_1()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  unPairDevice_1$Response(params?: UnPairDevice_1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return unPairDevice_1(this.http, this.rootUrl, params, context);
  }

  /**
   * Un pair the device.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `unPairDevice_1$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  unPairDevice_1(params?: UnPairDevice_1$Params, context?: HttpContext): Observable<void> {
    return this.unPairDevice_1$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `listSubVenues()` */
  static readonly ListSubVenuesPath = '/api/mng/Venue/listsubvenues';

  /**
   * List Subvenues for venue.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listSubVenues()` instead.
   *
   * This method doesn't expect any request body.
   */
  listSubVenues$Response(params?: ListSubVenues$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return listSubVenues(this.http, this.rootUrl, params, context);
  }

  /**
   * List Subvenues for venue.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listSubVenues$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listSubVenues(params?: ListSubVenues$Params, context?: HttpContext): Observable<void> {
    return this.listSubVenues$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getMenuItemsForSubvenue()` */
  static readonly GetMenuItemsForSubvenuePath = '/api/mng/Venue/getmenuitemsforsubvenue';

  /**
   * Get Menu item for subvenue.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMenuItemsForSubvenue()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMenuItemsForSubvenue$Response(params?: GetMenuItemsForSubvenue$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return getMenuItemsForSubvenue(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Menu item for subvenue.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMenuItemsForSubvenue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMenuItemsForSubvenue(params?: GetMenuItemsForSubvenue$Params, context?: HttpContext): Observable<void> {
    return this.getMenuItemsForSubvenue$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `listVenues_1()` */
  static readonly ListVenues_1Path = '/api/gmn/Venue/listvenues';

  /**
   * List venues.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listVenues_1()` instead.
   *
   * This method doesn't expect any request body.
   */
  listVenues_1$Response(params?: ListVenues_1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return listVenues_1(this.http, this.rootUrl, params, context);
  }

  /**
   * List venues.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listVenues_1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listVenues_1(params?: ListVenues_1$Params, context?: HttpContext): Observable<void> {
    return this.listVenues_1$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `listVenuesForCombo_1()` */
  static readonly ListVenuesForCombo_1Path = '/api/gmn/Venue/listvenuesforcombo';

  /**
   * List basic info for venues.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listVenuesForCombo_1()` instead.
   *
   * This method doesn't expect any request body.
   */
  listVenuesForCombo_1$Response(params?: ListVenuesForCombo_1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return listVenuesForCombo_1(this.http, this.rootUrl, params, context);
  }

  /**
   * List basic info for venues.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listVenuesForCombo_1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listVenuesForCombo_1(params?: ListVenuesForCombo_1$Params, context?: HttpContext): Observable<void> {
    return this.listVenuesForCombo_1$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getVenueDetails_1()` */
  static readonly GetVenueDetails_1Path = '/api/gmn/Venue/getvenuedetails';

  /**
   * Get venue details for venue id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getVenueDetails_1()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVenueDetails_1$Response(params?: GetVenueDetails_1$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDDtoAdvertiserVenueDetailsDto>> {
    return getVenueDetails_1(this.http, this.rootUrl, params, context);
  }

  /**
   * Get venue details for venue id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getVenueDetails_1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVenueDetails_1(params?: GetVenueDetails_1$Params, context?: HttpContext): Observable<DigiworkMaitreDDtoAdvertiserVenueDetailsDto> {
    return this.getVenueDetails_1$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDDtoAdvertiserVenueDetailsDto>): DigiworkMaitreDDtoAdvertiserVenueDetailsDto => r.body)
    );
  }

  /** Path part for operation `getVenueTimeZoneOffset()` */
  static readonly GetVenueTimeZoneOffsetPath = '/api/gmn/Venue/get-venue-time-zone-offset';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getVenueTimeZoneOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVenueTimeZoneOffset$Response(params?: GetVenueTimeZoneOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDDtoAdvertiserTimeZoneOffsetDto>> {
    return getVenueTimeZoneOffset(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getVenueTimeZoneOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVenueTimeZoneOffset(params?: GetVenueTimeZoneOffset$Params, context?: HttpContext): Observable<DigiworkMaitreDDtoAdvertiserTimeZoneOffsetDto> {
    return this.getVenueTimeZoneOffset$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDDtoAdvertiserTimeZoneOffsetDto>): DigiworkMaitreDDtoAdvertiserTimeZoneOffsetDto => r.body)
    );
  }

  /** Path part for operation `addVenue()` */
  static readonly AddVenuePath = '/api/gmn/Venue/addvenue';

  /**
   * Add new venue.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addVenue()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  addVenue$Response(params?: AddVenue$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return addVenue(this.http, this.rootUrl, params, context);
  }

  /**
   * Add new venue.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addVenue$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  addVenue(params?: AddVenue$Params, context?: HttpContext): Observable<void> {
    return this.addVenue$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteVenue()` */
  static readonly DeleteVenuePath = '/api/gmn/Venue/deletevenue';

  /**
   * Deletes venue.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteVenue()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteVenue$Response(params?: DeleteVenue$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteVenue(this.http, this.rootUrl, params, context);
  }

  /**
   * Deletes venue.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteVenue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteVenue(params?: DeleteVenue$Params, context?: HttpContext): Observable<void> {
    return this.deleteVenue$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateVenue()` */
  static readonly UpdateVenuePath = '/api/gmn/Venue/updatevenue';

  /**
   * Updates venue's data.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateVenue()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateVenue$Response(params?: UpdateVenue$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateVenue(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates venue's data.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateVenue$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateVenue(params?: UpdateVenue$Params, context?: HttpContext): Observable<void> {
    return this.updateVenue$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `listSubVenues_1()` */
  static readonly ListSubVenues_1Path = '/api/gmn/Venue/listsubvenues';

  /**
   * List Subvenues for venue.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listSubVenues_1()` instead.
   *
   * This method doesn't expect any request body.
   */
  listSubVenues_1$Response(params?: ListSubVenues_1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return listSubVenues_1(this.http, this.rootUrl, params, context);
  }

  /**
   * List Subvenues for venue.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listSubVenues_1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listSubVenues_1(params?: ListSubVenues_1$Params, context?: HttpContext): Observable<void> {
    return this.listSubVenues_1$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `addSubVenue()` */
  static readonly AddSubVenuePath = '/api/gmn/Venue/addsubvenue';

  /**
   * Add Subvenue.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addSubVenue()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  addSubVenue$Response(params?: AddSubVenue$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return addSubVenue(this.http, this.rootUrl, params, context);
  }

  /**
   * Add Subvenue.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addSubVenue$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  addSubVenue(params?: AddSubVenue$Params, context?: HttpContext): Observable<void> {
    return this.addSubVenue$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateSubVenue()` */
  static readonly UpdateSubVenuePath = '/api/gmn/Venue/updatesubvenue';

  /**
   * update Subvenue.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSubVenue()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateSubVenue$Response(params?: UpdateSubVenue$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateSubVenue(this.http, this.rootUrl, params, context);
  }

  /**
   * update Subvenue.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateSubVenue$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateSubVenue(params?: UpdateSubVenue$Params, context?: HttpContext): Observable<void> {
    return this.updateSubVenue$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteSubVenue()` */
  static readonly DeleteSubVenuePath = '/api/gmn/Venue/deletesubvenue';

  /**
   * Delete Subvenue.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteSubVenue()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSubVenue$Response(params?: DeleteSubVenue$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteSubVenue(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete Subvenue.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteSubVenue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSubVenue(params?: DeleteSubVenue$Params, context?: HttpContext): Observable<void> {
    return this.deleteSubVenue$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `listSubVenuesForCombo()` */
  static readonly ListSubVenuesForComboPath = '/api/gmn/Venue/listsubvenuesforcombo';

  /**
   * List Subvenues for combo.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listSubVenuesForCombo()` instead.
   *
   * This method doesn't expect any request body.
   */
  listSubVenuesForCombo$Response(params?: ListSubVenuesForCombo$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return listSubVenuesForCombo(this.http, this.rootUrl, params, context);
  }

  /**
   * List Subvenues for combo.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listSubVenuesForCombo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listSubVenuesForCombo(params?: ListSubVenuesForCombo$Params, context?: HttpContext): Observable<void> {
    return this.listSubVenuesForCombo$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
